export default __webpack_public_path__ + "static/duplicate_image.png";